import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Slider from "react-slick";
import AuthService from '../../../../controllers/AuthService';
import UserService from '../../../../controllers/UserService';
import $ from 'jquery';

const TopStrengthInRoom = props => {

    const roomId = props.roomId ?? null
    const filterYear = props.filterYear ?? null
    const filterTerm = props.filterTerm ?? null
    const [roomStrengths, setRoomStrengths] = useState('');
    const [roomStrengthsMobile, setRoomStrengthsMobile] = useState([]);
    const user = AuthService.getCurrentUser();

    useEffect(() => {
        if (!roomId || !filterYear || !filterTerm) {
            return;
        }

        var filterT1 = {
            "domain": user.domain.name,
            "year": filterYear,
            "term": filterTerm,
            "role": "STUDENT",
            "roomId": roomId,

        };
        UserService.summaryStrength(filterT1).then((result) => {

            var studentData = result.student || [];
            console.log('summaryStrength(filterT1', studentData);

            var htmlDesktop = '';
            var htmlMobile = [];
            $.each(studentData, function (index, value) {

                htmlMobile.push({
                    'total': `${value.total} ครั้ง`,
                    'image': `/images/strengths/cards/${value.name}.png`,
                })

                htmlDesktop += `<div class="pt-4 col-lg-4 col-12 text-center t-20" > <img src="/images/strengths/cards/${value.name}.png" class="imgCard"/><br>${value.total} ครั้ง</div>`;

            });

            var htmlDesktop2 = <div dangerouslySetInnerHTML={{ __html: htmlDesktop }} className="row bg-lightness5-blue pb-5 px-5 mrl-0px border-radius-bottom-7px" key="topS" />

            setRoomStrengthsMobile(htmlMobile);
            setRoomStrengths(htmlDesktop2);
        });

    }, [roomId, filterYear, filterTerm])

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        slidesPerRow: 1,
        centerMode: true,
        arrows: false
    };

    return (
        <>
            <div className='mt-3 mb-3 mt-lg-5' />
            <Row className="font-sarabun d-block d-lg-none ">
                <Col xs={12} className="text-white bg-lightness2-blue m-0">
                    <div className="activity-top-strength text-center mb-0 py-2">จุดเด่นของนักเรียนในห้องเรียน</div>

                </Col>
                <Col xs={12} className="m-0 bg-lightness5-blue">
                    <h3 className="text-center  m-0 p-3 ">5 จุดเด่นที่ถูกเลือกมากที่สุดในห้องเรียนจากการประเมินทั้งหมด</h3>

                </Col>
            </Row>

            <Row className="font-sarabun d-none d-lg-flex">
                <Col xs={12} className="pt-2 text-white">
                    <div className="font-s30 text-center bg-lightness2-blue border-radius-top-7px mb-0 py-2">จุดเด่นของนักเรียนในห้องเรียน</div>
                </Col>
                <Col xs={12} className="m-0">
                    <h3 className="text-center  mt-0 mb-0 p-3 bg-lightness5-blue">5 จุดเด่นที่ถูกเลือกมากที่สุดในห้องเรียน<span className="doNotWrap">จากการประเมินทั้งหมด</span></h3>
                </Col>
            </Row>
            {roomStrengthsMobile[0] || roomStrengthsMobile[1] || roomStrengthsMobile[2] || roomStrengthsMobile[3] || roomStrengthsMobile[4] ?
                <Slider  {...settings} className="row d-block d-lg-none bg-lightness5-blue pb-4">

                    {roomStrengthsMobile[0] ? (

                        <div style={{ "marginRight": "20px" }} >
                            <div class="text-center t-20"> <img src={roomStrengthsMobile[0].image} class="imgCard" /> {roomStrengthsMobile[0].total}</div>
                        </div>
                    ) : ''}


                    {roomStrengthsMobile[1] ? (
                        <div>
                            <div class="text-center t-20"> <img src={roomStrengthsMobile[1].image} class="imgCard" /> {roomStrengthsMobile[1].total}</div>
                        </div>
                    ) : ''}

                    {roomStrengthsMobile[2] ? (
                        <div>
                            <div class="text-center t-20"> <img src={roomStrengthsMobile[2].image} class="imgCard" /> {roomStrengthsMobile[2].total}</div>
                        </div>
                    ) : ''}


                    {roomStrengthsMobile[3] ? (
                        <div>
                            <div class="text-center t-20"> <img src={roomStrengthsMobile[3].image} class="imgCard" /> {roomStrengthsMobile[3].total}</div>
                        </div>
                    ) : ''}


                    {roomStrengthsMobile[4] ? (
                        <div>
                            <div class="text-center t-20"> <img src={roomStrengthsMobile[4].image} class="imgCard" /> {roomStrengthsMobile[4].total}</div>
                        </div>
                    ) : ''}



                </Slider>
                : <div className="text-center bg-lightness5-blue font-sarabun">ยังไม่มีผลประเมิน</div>
            }

            <Row className="d-none d-lg-flex">
                <Col className="">
                    {roomStrengths}
                </Col>
            </Row>
        </>
    )

}

export default TopStrengthInRoom